var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTruckGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 6,
    fill: "#81D61E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 9H15.75V6H5.25C4.425 6 3.75 6.675 3.75 7.5V15.75H5.25C5.25 16.995 6.255 18 7.5 18C8.745 18 9.75 16.995 9.75 15.75H14.25C14.25 16.995 15.255 18 16.5 18C17.745 18 18.75 16.995 18.75 15.75H20.25V12L18 9ZM17.625 10.125L19.095 12H15.75V10.125H17.625ZM7.5 16.5C7.0875 16.5 6.75 16.1625 6.75 15.75C6.75 15.3375 7.0875 15 7.5 15C7.9125 15 8.25 15.3375 8.25 15.75C8.25 16.1625 7.9125 16.5 7.5 16.5ZM9.165 14.25C8.7525 13.7925 8.1675 13.5 7.5 13.5C6.8325 13.5 6.2475 13.7925 5.835 14.25H5.25V7.5H14.25V14.25H9.165ZM16.5 16.5C16.0875 16.5 15.75 16.1625 15.75 15.75C15.75 15.3375 16.0875 15 16.5 15C16.9125 15 17.25 15.3375 17.25 15.75C17.25 16.1625 16.9125 16.5 16.5 16.5Z",
    fill: "#0B7340"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckGreen);
export default __webpack_public_path__ + "static/media/truck-green.795de8ab9c546dc6d9291a92ca9937f5.svg";
export { ForwardRef as ReactComponent };